// <s-photo-compare> — manual before/after comparison slider.
// Drag (mouse or touch) anywhere on the frame, or focus the slider and use the arrow keys,
// Home/End or Page Up/Down (native range input). Never moves on its own.
// Until this script runs, the markup shows the two photos side by side (fallback).
class SPhotoCompare extends HTMLElement {
  #ac = null;

  connectedCallback() {
    const input = this.querySelector("[data-compare-input]");
    const frame = this.querySelector("[data-compare-frame]");
    if (!input || !frame) return;

    this.#ac = new AbortController();
    const signal = this.#ac.signal;
    let dragging = false;

    const apply = (value) => {
      const pos = Math.min(100, Math.max(0, Number(value)));
      input.value = String(pos);
      this.style.setProperty("--pos", `${pos}%`);
      input.setAttribute("aria-valuetext", `${Math.round(pos)}%`);
    };

    const fromPointer = (event) => {
      const rect = frame.getBoundingClientRect();
      if (rect.width === 0) return;
      let pct = ((event.clientX - rect.left) / rect.width) * 100;
      if (getComputedStyle(this).direction === "rtl") pct = 100 - pct;
      apply(pct);
    };

    input.addEventListener("input", () => apply(input.value), { signal });

    frame.addEventListener(
      "pointerdown",
      (event) => {
        if (event.button !== 0) return;
        dragging = true;
        frame.setPointerCapture?.(event.pointerId);
        fromPointer(event);
        input.focus({ preventScroll: true });
      },
      { signal }
    );
    frame.addEventListener("pointermove", (event) => dragging && fromPointer(event), { signal });
    const stop = () => (dragging = false);
    frame.addEventListener("pointerup", stop, { signal });
    frame.addEventListener("pointercancel", stop, { signal });

    apply(input.value || 50);
    this.setAttribute("data-ready", "");
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get("s-photo-compare")) customElements.define("s-photo-compare", SPhotoCompare);
